import { formatTimestampHuman } from "../date-utils";
export const portalUserDtoFields = [{
        name: "login",
        title: "Login"
    }, {
        name: "email",
        title: "E-mail"
    }, {
        name: "lastName",
        title: "Cognome"
    }, {
        name: "firstName",
        title: "Nome"
    }, {
        name: "portalRoleCode",
        title: "Ruolo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered"
    }, {
        name: "active",
        title: "Attivo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.active === 1 ? "check" : "close"}</i>`
    }, {
        name: "lastLoginOn",
        title: "Ultimo accesso",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.lastLoginOn)
    }];
